import { postFetch } from '../fetch';

import { apiConfig } from '../config';

interface AddStudentsRequest {
    clessonId: number;
    studentIds: Array<number>;
}

export function postAddStudentsToLesson(requestData: AddStudentsRequest):Promise<void> {
    const { apiPostAddStudentsToLesson } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostAddStudentsToLesson}`, requestData);
}
